// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69de4c5d","455":"195bf4e3","946":"948bb1c8"}[chunkId] + ".chunk.js";
};